export function TabLoadBanner(props: {
  mode: 'create' | 'edit';
  isLoading?: boolean;
  error?: string | null;
  loadingLabel: string; // e.g. "Loading locations…"
}) {
  const { mode, isLoading, error, loadingLabel } = props;

  if (mode !== 'edit') return null;
  if (!isLoading && !error) return null;

  return (
    <div className="text-muted-foreground text-sm">
      {isLoading ? loadingLabel : null}
      {error ? `${isLoading ? ' ' : ''}Failed to load: ${error}` : null}
    </div>
  );
}
